import { AccordionPanel } from 'grommet'

export default AccordionPanel
